import { LocalStorage } from '@ngx-pwa/local-storage';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class StorageService {

  constructor(protected localStorage: LocalStorage) {}

  getUUID(): Observable<string> {
    return this.localStorage.getItem<string>('uuid');
  }

  setUUID(uuid: string): Observable<boolean> {
    return this.localStorage.setItem('uuid', uuid)
  }

  getSessionCode(): Observable<string> {
    return this.localStorage.getItem<string>('sessionCode');
  }

  setSessionCode(sessionCode: string): Observable<boolean> {
    return this.localStorage.setItem('sessionCode', sessionCode)
  }

  clearSessionCode(): Observable<boolean>  {
    return this.localStorage.removeItem('sessionCode');
  }

  getCategories(): Observable<string[]> {
    return this.localStorage.getItem<string[]>('categories');
  }

  setCategories(categories: any[]): Observable<boolean> {
    return this.localStorage.setItem('categories', JSON.stringify(categories))
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/storage.service.ts